<template>
  <transition name="fade-scale">
    <ul class="ui-activity-picker" v-show="value" @touchmove.stop="() => false">
      <li
        class="activity-item"
        v-for="(item, index) in activityType"
        :key="`tab_activity_${index}`"
        :class="activeIndex === index ? 'active' : ''"
        @click="handleChooseActivity(item, index)"
      >
        {{ item.label }}
      </li>
    </ul>
  </transition>
</template>

<script>
export default {
  name: "uiActivityPicker",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    activityType: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      activeIndex: ""
    }
  },
  methods: {
    handleChooseActivity(activityItem, index) {
      this.activeIndex = index
      this.$emit("chooseActivity", activityItem)
      this.$emit("input", false)
    },
    initDefaultActivity() {
      let s = new URLSearchParams(location.search)
      let zid = s.get("zid")
      if (zid) {
        const defaultActivityIndex = this.activityType.findIndex(item => item.id == zid)
        this.activeIndex = defaultActivityIndex
        this.handleChooseActivity(this.activityType[this.activeIndex], this.activeIndex)
      } else {
        const defaultActivityIndex = this.activityType.findIndex(item => item.isDefault)
        if (defaultActivityIndex > -1) {
          this.activeIndex = defaultActivityIndex
        }
      }
    }
  },
  watch: {
    activityType() {
      this.initDefaultActivity()
    }
  },
  mounted() {
    this.initDefaultActivity()
  }
}
</script>

<style lang="scss" scoped>
.ui-activity-picker {
  position: absolute;
  top: calc(100%);
  left: 0;
  width: 100%;
  transform-origin: 50% 0;
  background: #ffffff;
  max-height: 3.8rem;
  overflow: auto;
  width: 100%;
  font-family: PingFangSC-Regular;
  font-size: 0.32rem;
  color: #333333;
  letter-spacing: 0;
  text-align: center;
  line-height: 0.8rem;
  -webkit-overflow-scrolling: touch;
  .activity-item {
    &.active {
      font-family: PingFangSC-Regular;
      font-size: 0.32rem;
      color: #303233;
      font-weight: bold;
    }
    &:active {
      opacity: 0.7;
    }
  }
}
.fade-scale-enter,
.fade-scale-leave-to {
  opacity: 0;
  transform: scaleY(0);
}
.fade-scale-enter-to,
.fade-scale-leave {
  opacity: 1;
  transform: scaleY(1);
}
.fade-scale-enter-active,
.fade-scale-leave-active {
  transition: all 0.3s ease-in-out;
}
</style>
